import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

type NumberedStepsProps = {
	steps: string[];
	size?: "small" | "large";
};

/** Numbered instruction list shared by the non-RFID welcome and handoff steps (prototype). */
export const NumberedSteps = ({ steps, size = "small" }: NumberedStepsProps) => {
	const isLarge = size === "large";
	return (
		<StepList isLarge={isLarge}>
			{steps.map((label, index) => (
				<StepRow key={label}>
					<StepNumber
						sx={{
							width: isLarge ? 56 : 40,
							height: isLarge ? 56 : 40,
							fontSize: isLarge ? "1.75rem" : "1.25rem",
						}}
					>
						{index + 1}
					</StepNumber>
					<Typography
						sx={{
							color: "white",
							fontSize: isLarge ? "2rem" : "1.5rem",
							fontWeight: 600,
							lineHeight: 1.2,
						}}
					>
						{label}
					</Typography>
				</StepRow>
			))}
		</StepList>
	);
};

const StepList = styled(Box, { shouldForwardProp: (prop) => prop !== "isLarge" })<{ isLarge: boolean }>(
	({ theme, isLarge }) => ({
		display: "flex",
		flexDirection: "column",
		gap: theme.spacing(isLarge ? 1.5 : 1),
		width: "100%",
	}),
);

const StepRow = styled(Box)(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	gap: theme.spacing(2),
}));

const StepNumber = styled(Box)(({ theme }) => ({
	flex: "none",
	borderRadius: "50%",
	backgroundColor: theme.palette.common.white,
	color: theme.palette.copper.dark,
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	fontWeight: 900,
}));
